import "./Team03.css";

import moody from "./../../../img/team/Moody.jpg";
import uno from "./../../../img/team/Uno.jpg";
import yousif from "./../../../img/team/Yousif.jpg";
import ibrahim from "./../../../img/team/Ibrahim.jpg";
import nazz from "./../../../img/team/Nazz.jpg";
import moe from "./../../../img/team/Moe.jpg";
import yamen from "./../../../img/team/Yamen.jpg";
import silo from "./../../../img/team/Silo.jpg";
import diyar from "./../../../img/team/Diyar.jpg";
import derar from "./../../../img/team/Derar.jpg";
import basel from "./../../../img/team/Basel.jpg";
import ahmad from "./../../../img/team/Ahmad.jpg";
import redar from "./../../../img/team/Redar.jpg";
import razaa from "./../../../img/team/Razaa.jpg";
import mohamed from "./../../../img/team/Mohamed.jpg";

function Team03() {
  const teamMembers = [
    {
      name: "Moody",
      location: "Columbia St",
      image: moody,
      unavailableDays: ["wed"],
    },
    {
      name: "Uno",
      location: "Lester St",
      image: uno,
      unavailableDays: ["tue"],
    },
    {
      name: "Yousif",
      location: "Columbia St",
      image: yousif,
      unavailableDays: ["tue"],
    },
    {
      name: "Ibrahim",
      location: "Columbia St",
      image: ibrahim,
      unavailableDays: ["mon"],
    },
    {
      name: "Nazz",
      location: "Lester St",
      image: nazz,
      unavailableDays: ["sat"],
    },
    {
      name: "Moe",
      location: "Columbia St",
      image: moe,
      unavailableDays: ["sun"],
    },
    {
      name: "Yamen",
      location: "Lester St",
      image: yamen,
      unavailableDays: ["mon", "fri"],
    },
    {
      name: "Silo",
      location: "Lester St",
      image: silo,
      unavailableDays: ["fri", "sat", "sun", "mon", "tue"],
    },
    {
      name: "Diyar",
      location: "Lester St",
      image: diyar,
      unavailableDays: ["thu"],
    },
    {
      name: "Derar",
      location: "Columbia St",
      image: derar,
      unavailableDays: ["wed"],
    },
    /* {
      name: "Basel",
      location: "Kingsway Dr",
      image: basel,
      unavailableDays: ["tue"],
    },*/
    {
      name: "Ahmad",
      location: "Lester St",
      image: ahmad,
      unavailableDays: ["sun"],
    },
    {
      name: "Redar",
      location: "Lester St",
      image: redar,
      unavailableDays: ["thu"],
    },
    {
      name: "Razaa",
      location: "Columbia St",
      image: razaa,
      unavailableDays: ["mon"],
    },
    {
      name: "Mohamed",
      location: "Kingsway Dr",
      image: mohamed,
      unavailableDays: ["mon"],
    },
  ];

  const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

  const isDayUnavailable = (member, day) => {
    return member.unavailableDays.includes(day);
  };

  return (
    <div className="Team03 section" id="Team03">
      <div className="container">
        <div className="intro">
          <p className="eyebrow">OUR TEAM </p>
          <h2>Meet The Team</h2>
          <p>We bring years of expertise to every chair.</p>
        </div>

        <div className="Team03-box">
          {teamMembers.map((member, index) => (
            <div key={index} className="Team03-card">
              <img src={member.image} alt="" />
              <div className="Team03-card-text">
                <p className="name">{member.name}</p>
                <p className="location">{member.location}</p>

                <div className="Team03-card-availability">
                  {days.map((day) => (
                    <p
                      key={day}
                      className={
                        isDayUnavailable(member, day) ? "unavailable" : ""
                      }
                    >
                      {day.toUpperCase()}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Team03;
